import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemHealthMonitor = ({ systemHealth }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'healthy':
        return 'text-green-600 bg-green-50 border-green-200';
      case 'degraded':
        return 'text-yellow-600 bg-yellow-50 border-yellow-200';
      case 'error':
        return 'text-red-600 bg-red-50 border-red-200';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'healthy':
        return 'CheckCircle';
      case 'degraded':
        return 'AlertTriangle';
      case 'error':
        return 'XCircle';
      default:
        return 'HelpCircle';
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 sm:p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="Activity" size={20} strokeWidth={2} />
          System Health
        </h2>
        <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full border ${
          getStatusColor(systemHealth?.status)
        }`}>
          <Icon name={getStatusIcon(systemHealth?.status)} size={16} strokeWidth={2} />
          <span className="text-sm font-medium capitalize">{systemHealth?.status}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-background rounded-lg p-4 border border-border">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Zap" size={16} strokeWidth={2} className="text-blue-600" />
            <p className="text-sm text-muted-foreground">Uptime</p>
          </div>
          <p className="text-2xl font-heading font-bold text-foreground">{systemHealth?.uptime}%</p>
        </div>

        <div className="bg-background rounded-lg p-4 border border-border">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Clock" size={16} strokeWidth={2} className="text-green-600" />
            <p className="text-sm text-muted-foreground">Response Time</p>
          </div>
          <p className="text-2xl font-heading font-bold text-foreground">{systemHealth?.responseTime}ms</p>
        </div>

        <div className="bg-background rounded-lg p-4 border border-border">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="AlertCircle" size={16} strokeWidth={2} className="text-orange-600" />
            <p className="text-sm text-muted-foreground">Error Rate</p>
          </div>
          <p className="text-2xl font-heading font-bold text-foreground">{systemHealth?.errorRate}%</p>
        </div>
      </div>
    </div>
  );
};

export default SystemHealthMonitor;